// src/App.jsx
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import Header from './components/Header';
import Home from './pages/Home';
import Blogs from './pages/Blogs';
import About from './pages/About';
import Magazines from './pages/Magazines';
import Footer from './components/Footer';
import FlipBookReader from "./pages/FlipBookReader";
import Background from "./components/Background";
import Admin from './pages/Admin/Admin';
import { AdminMagazine } from './pages/Admin/Magazines';
import { AdminBlogs } from './pages/Admin/Blogs';
import { AdminHighlights } from './pages/Admin/Highlights.jsx';
import React, { useEffect } from "react";
import WriteBlog from './pages/Admin/WriteBlog';
import BlogDetail from './pages/BlogDetail.jsx';
import Adminlogin from './pages/Admin/login.jsx';
import Forgotpassword from "./pages/Admin/forgot_password.jsx"
import ResetPassword from './pages/Admin/reset_password.jsx';
import Dashboard from './pages/Admin/dashboard.jsx';
import { LoaderProvider } from './context/LoaderContext';
import Loader from './components/Loader';


function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin")|| location.pathname === "/login"||location.pathname === "/forgot-password"||location.pathname === "/reset-password";

  const [isFullscreen, setIsFullscreen] = useState(false);

  // Sticky header effect
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".header");
      if (header) {
        header.classList.toggle("scrolled", window.scrollY > 20);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Background />
      {!isAdminRoute && !isFullscreen && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/magazines" element={<Magazines />} />
        <Route path="/about" element={<About />} />
        <Route path="/reader/:id" element={<FlipBookReader setIsFullscreen={setIsFullscreen} />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />


        <Route path="/admin" element={<Admin />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="magazines" element={<AdminMagazine />} />
          <Route path="blogs" element={<AdminBlogs />} />
          <Route path="write-blog/:id/:blogid" element={<WriteBlog />} />
          <Route path="highlights" element={<AdminHighlights />} />
          <Route path="dashboard" element={<Dashboard />} />
        </Route>
        <Route path="/login" element={<Adminlogin />} />
        <Route path="/forgot-password" element={<Forgotpassword/>}/>
        <Route path="/reset-password" element={<ResetPassword/>}/>


        <Route path="*" element={<div className="p-5"><h1>404 - Not Found</h1></div>} />
      </Routes>
      {!isAdminRoute && !isFullscreen && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <LoaderProvider>
        <Loader />
        <Layout />
      </LoaderProvider>
    </Router>
  );
}